import React from "react";
import { Card, CardBody, CardTitle, CardSubtitle, CardText } from "reactstrap";
import { FormattedMessage } from "react-intl";
import StudentStatus from "./StudentStatus";

const StudentResult = props => {
  let resultStatus;

  if (props.result.status)
    resultStatus = <StudentStatus status={props.result.status} />;

  return (
    <Card>
      <CardBody>
        <CardTitle>
          {props.result.module}{" "}
          <small className="pull-right">{resultStatus}</small>
        </CardTitle>
        <CardSubtitle className="text-primary">
          <FormattedMessage id="Course" />: {props.result.courseName}{" "}
          <small className="pull-right">
            <i className="fa fa-clock-o" />
          </small>
        </CardSubtitle>
        <CardText>
          <FormattedMessage id="View.Teacher.Results" />: {props.result.score}/{props.result.maxScore}
          <br />
          <FormattedMessage id="ActivityPoints" />: {props.result.activityPoints}/
          {props.result.maxActivityPoints}
          <br />
          <FormattedMessage id="Views.Teacher.TeacherModule.CourseLimit" />: {props.result.approveLimit}
        </CardText>
      </CardBody>
    </Card>
  );
};

export default StudentResult;
